import { render, staticRenderFns } from "./CxCDiferenceDetail.vue?vue&type=template&id=9f4811c4&"
import script from "./CxCDiferenceDetail.vue?vue&type=script&lang=js&"
export * from "./CxCDiferenceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports